<!-- =========================================================================================
  File Name: TheCustomizer.vue
  Description: Template Customizer
  Component Name: TheCustomizer
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="theme-customizer">

<!--    todo: side task bar button-->
    <!-- Open Customizer Button -->
    <vs-button
      @click.stop="onClickOpenTaskSideBar"
      color="primary"
      type="filled"
      class="customizer-btn"
      icon-pack="feather"
      icon="icon-list" />

    <!-- Customizer Content -->
    <vs-sidebar
      click-not-close
      hidden-background
      position-right
      v-model="active"
      class="items-no-padding">
      <div class="h-full">

        <div class="customizer-header mt-6 flex items-center justify-between px-6">
          <div>
            <h4>TASKS</h4>
            <!--            <small>Customize & Preview in Real Time</small>-->
          </div>
          <feather-icon icon="XIcon" @click.stop="active = false" class="cursor-pointer"></feather-icon>
        </div>

        <vs-divider class="mb-0" />

        <div class="vx-row my-5 mx-3">
          <div class="vx-col w-full ml-auto">
            <vs-button @click.native="onClickTaskCreate" class="float-right w-full my-4"  size="small" color="primary" type="border" icon-pack="feather" icon="icon-plus">ADD TASK</vs-button>
          </div>
        </div>
        <div class="vx-row my-5 mx-3">
          <div class="vx-col w-full ml-auto">
            <ul class="centerx flex vx-card card-border no-shadow px-2 pb-6 pt-8">
              <li v-for="(option, index) in options" :key="index">
                <vs-radio class="mr-8" v-model="filter_id" :vs-value="option.id" @input="handleFilter($event)">{{ option.name }}</vs-radio>
              </li>
            </ul>
            <!-- <v-select  :clearable="true" placeholder=""
                       :options="options"
                       :reduce="option => option.id"
                       v-model="filter_id"
                       label="name"
                       @input="handleFilter($event)"
                       ></v-select> -->
          </div>
        </div>


        <!-- <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--site-task-bar p-0 mb-10"
                   :settings="settings" :key="$vs.rtl"> -->


          <div class="vx-row my-3 mx-3">
            <div class="vx-col w-full">
              <ul class="page-suggestions-list">
               <span v-for="(task, index) in tasks" :key="index">
               <li class="page-suggestion flex items-center mb-4 p-2 rounded-md hover:bg-grey-light cursor-pointer transition-all duration-150">
                 <div class="leading-tight">
                   <p class="font-medium">{{ task.name }}</p>
                   <span class="text-sm">
                    {{ task.note }}
                   </span>
                   <p class="text-xs mt-2">
                      <span :class="`text-${taskStatusColorFactory(task.status.name)} text-xs font-extrabold mb-3`">{{ task.status.name }}</span>
                      <br>
                      Created: {{ __dateTimeFormatterToDate(task.created_at) }}
                      <span v-if="task.due_date || task.due_time"> . Due: {{ [task.due_date, task.due_time].filter(Boolean).join(' ') }}</span> 
                      <span v-if="filter_id === 1" >. By {{ task.created_by }}</span>
                   </p>
                 </div>
                 <div class="ml-auto">
                   <div class="flex">
                     <vx-tooltip text="Edit Task" position="top" class="ml-1">
                        <vs-button @click.native="onClickTaskEdit(task.id)" size="small"
                                   color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                     <vx-tooltip v-if="filter_id !== 1" text="Delete Task" position="top" class="ml-1">
                        <vs-button @click.native="onClickTaskDelete(task.id)" size="small"
                                   color="danger" type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                   </div>
                 </div>
               </li>
               <vs-divider/>
               </span>
              </ul>
              <!--            <div class="text-center" style="cursor: pointer">-->
              <!--              show completed tasks-->
              <!--            </div>-->
            </div>
          </div>
        <!-- </component> -->
      </div>
    </vs-sidebar>
    <create-task-pop-up ref="createTaskPopUp"/>
  </div>
</template>


<script>
import vSelect from 'vue-select'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {mapActions, mapGetters} from "vuex";
import ErrorMessages from "@/mixins/ErrorMessages";
import SuccessMessage from "@/mixins/SuccessMessage";

import CreateTaskPopUp from "@/components/popups/tasks/CreateTaskPopUp";

export default {
  data () {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .30
      },
      filter_id: 1,
      active: false,
      popupActive: false,
      popUpTitle: '',
      options:[
        {id: 1, name: 'Assigned to Me'},
        {id: 2, name: 'Assigned by Me'},
      ],
      form: {
        name: '',
        note: '',
      },
      statuses: [
        { name: 'Pending', key: 'Pending', color: 'dark' },
        { name: 'In Progress', key: 'In-Progress', color: 'warning' },
        { name: 'On Hold', key: 'On-Hold', color: 'dark' },
        { name: 'Completed', key: 'Completed', color: 'primary' },
        { name: 'Cancelled', key: 'Cancelled', color: 'danger' },
      ],
    }
  },
  watch: {
    layoutType (val) {

      // Reset unsupported options
      if (val === 'horizontal') {
        if (this.themeMode === 'semi-dark') this.themeMode = 'light'
        if (this.navbarType === 'hidden')   this.navbarTypeLocal = 'floating'
        this.$emit('updateNavbarColor', '#fff')
      }
    },
    // When Vuex changes -> update local
    'side_task_bar_data.active': {
      immediate: true,
      handler(val) {
        if (this.active !== val) {
          this.active = val
          this.$refs.createTaskPopUp.openPopup(this.side_task_bar_data.id)
        }
      }
    },

    // When local changes -> update Vuex
    active(val) {
      if (this.side_task_bar_data.active !== val) {
        this.$store.commit('TOGGLE_SIDE_TASK_BAR', { active: val, id: null })
      }

      // 👇 Fetch tasks automatically when sidebar opens
      if (val) {
        if (this.filter_id === 1) {
          this.fetchTasksByYou()
        } else if (this.filter_id === 2) {
          this.fetchTasks()
        }
      }
    }
  },
  computed: {
    ...mapGetters(['tasks', 'side_task_bar_data']),
    scrollbarTag () { return this.$store.getters.scrollbarTag },

  },
  mixins: [ErrorMessages, SuccessMessage],
  mounted() {

  },
  methods: {
    ...mapActions(['fetchTasks', 'deleteTask','fetchTasksByYou']),
    onClickOpenTaskSideBar() {
      this.fetchTasksByYou()
      this.active = !this.active
    },
    updatePrimaryColor (color) {
      this.primaryColor = color
      this.$vs.theme({ primary: color })
    },
    onClickTaskEdit (task_id) {
      this.$refs.createTaskPopUp.openPopup(task_id)
    },
    onClickTaskDelete(id) {
      try {
        this.deleteTask(id)
        this.showSuccessMessage('Task deleted successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    handleFilter(e) {
      if(this.filter_id === 1) {
        this.fetchTasksByYou()
      }
      if(this.filter_id === 2){
        this.fetchTasks()
      }
    },
    onClickTaskCreate () {
     this.$refs.createTaskPopUp.openPopup()
    },
    taskStatusColorFactory(status) {
      const find = this.statuses.find((x) => x.key === status)
      return find ? find.color : 'dark'
    },
  },
  components: {
    VuePerfectScrollbar,
    CreateTaskPopUp,
    'v-select': vSelect,
  },
}

</script>


<style lang="scss">
.scroll-area {
  position: relative;
  margin: auto;
  width: 400px;
  height: 800px;
}
  #theme-customizer {
    .vs-sidebar {
      position: fixed;
      z-index: 52000;
      width: 600px;
      max-width: 90vw;
      // @apply shadow-lg;
      box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08);
    }
  }

  .customizer-btn {
    position: fixed;
    top: 10%;
    right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    z-index: 50000;

    /*.vs-icon {*/
    /*  animation: spin 1.5s linear infinite;*/
    /*}*/
  }

.scroll-area--customizer {
  height: calc(100% - 5rem);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>

